import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourToMinute'
})
export class HourToMinutePipe implements PipeTransform {

    transform(value: number): string {
      if (!value && value !== 0) {
        return '';
      }
  
      const totalMinutes = value * 60;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = Math.floor(totalMinutes % 60);
      const seconds = Math.round((totalMinutes % 1) * 60);
  
      let result = '';
  
      if (hours > 0) {
        result += `${hours} hour${hours !== 1 ? 's' : ''} `;
      }
  
      if (minutes > 0) {
        result += `${minutes} minute${minutes !== 1 ? 's' : ''} `;
      }
  
      if (seconds > 0) {
        result += `${seconds} second${seconds !== 1 ? 's' : ''}`;
      }
  
      if (!result) {
        result = '0 seconds';
      }
  
      return result.trim();
    }  
}